exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-3decd905] {\n  width: 50%;\n  margin: 0 auto;\n  height: 100%;\n  padding: 0.3125rem;\n  background-color: #ffffff;\n  color: #111315;\n}\n.wrapper h1[data-v-3decd905] {\n  text-align: center;\n}\n.wrapper h4[data-v-3decd905] {\n  padding: 0.104167rem 0.104167rem 0.104167rem 0;\n  font-weight: 700;\n}\n.wrapper p[data-v-3decd905] {\n  font-size: 0.083333rem;\n  line-height: 0.166667rem;\n  text-align: justify;\n  word-break: break-all;\n}\n.wrapper .secondary-indent[data-v-3decd905] {\n  text-indent: 2em;\n}\n.wrapper .tertiary-indent[data-v-3decd905] {\n  text-indent: 4em;\n}", ""]);

// exports
